import { render } from "./RecentVisitListLayout.vue?vue&type=template&id=6d44f007&scoped=true"
import script from "./RecentVisitListLayout.vue?vue&type=script&lang=js"
export * from "./RecentVisitListLayout.vue?vue&type=script&lang=js"

import "./RecentVisitListLayout.vue?vue&type=style&index=0&id=6d44f007&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d44f007"]])

export default __exports__